export const API_EXTERNAL_ENDPOINT = 'accessibility-page'

export const API_INTERNAL_ENDPOINT = 'strapi/accessibility-page'
